import { render, staticRenderFns } from "./riwayat_transaksi.vue?vue&type=template&id=bc7fd350&scoped=true&"
import script from "./riwayat_transaksi.vue?vue&type=script&lang=js&"
export * from "./riwayat_transaksi.vue?vue&type=script&lang=js&"
import style0 from "./riwayat_transaksi.vue?vue&type=style&index=0&id=bc7fd350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7fd350",
  null
  
)

export default component.exports